/// <amd-module name="Pipeline/Analytics/PipelineDurationAgentWaitCard/ControllerView/PipelineDurationAgentWaitCard" />
import { VisualTemplate } from "Analytics/Shared/Visuals/Common/Components/VisualTemplate";
import * as Resources from "Pipeline/Analytics/PipelineDurationAgentWaitCard/Resources";
import * as React from "react";
import { format } from "VSS/Core/Util/String";
import { IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { Icon } from "VSSUI/Icon";

export interface IPipelineDurationRegressionCardProps extends IVssComponentProperties {
    // store: PipelineDurationRegressionStore;
    titleClassName?: string;
    // onDataRendered?: () => void;
    errorText?: string;
}

export class PipelineDurationAgentWaitCard extends VssComponent<IVssComponentProperties, {}> {
    public render(): JSX.Element {
        return (
            <VisualTemplate className={this.props.className} title={Resources.PipelineAgentWaitCardTitle} titleClassName={this.props.titleClassName}>
                {this._getElementToDisplay()}
            </VisualTemplate>
        );
    }

    private _getElementToDisplay(): JSX.Element {
        return (
            <div className="pipeline-duration-agentwait-container flex-column">
                <span>1 min | 4 runs</span>
                {
                    <div className="pipeline-duration-trend">
                        <Icon className="trend-icon fontSizeL" iconName="Up" />
                        <span>{format(Resources.PipelineTrendInsight, 20, 14)}</span>
                    </div>
                }
            </div>
        );
    }
}
